import { z } from 'zod';
import { integerSchema } from '../validation';

export const temperatureTypeSchema = z.enum(['chilled', 'frozen', 'hot', 'dry']);
export type TemperatureType = z.infer<typeof temperatureTypeSchema>;

export const temperatureDegreeSchema = z.object({
  min: integerSchema,
  max: integerSchema,
});
export type TemperatureDegree = z.infer<typeof temperatureDegreeSchema>;

export const temperatureSchema = z.object({
  /** the type of temperature (dry/frozen/hot/etc)  */
  types: z.array(temperatureTypeSchema),
  /**
   * the degree of temperature needed / or can handle .
   *
   * if empty, then it means only dry temperature is supported
   */
  degree: temperatureDegreeSchema.optional(),
});

export type Temperature = z.infer<typeof temperatureSchema>;

/** this is the same as {@link Temperature} but with an id.
 * The main reason for having an id is for easier looping through the list of temperatures in the frontend.
 * */
export type TemperatureWithId = Temperature & { id: number };
